import type { Starter } from '@wellread/api';
import { Icon } from '../ui';

/**
 * The ask bar's words: Explore's field at the top of Home, for a reader with
 * books and for a new one. Here, apart from Explore's code, so Home can draw
 * the bar's shell while that code loads.
 */

/** A reader with books: the label, the examples the field shows in turn, and the line under it. */
export const LIBRARY_BAR = {
  label: 'Ask your library',
  examples: [
    'Ask anything about your books',
    'What should I read next?',
    'Find the passage where an idea first comes up',
    'Where do two of my books disagree?',
  ],
  caption: 'Answers come from your books, with the passage each one is from.',
} as const;

/** A new reader, before any book. */
export const FIRST_BAR = {
  label: 'Ask your library',
  examples: [
    'Ask what to read, or about a book',
    'Suggest a novel for a long train journey',
    'What should I read to understand distributed systems?',
    'Books like The Remains of the Day',
  ],
  caption: 'Explore suggests books and answers from the ones you add.',
} as const;

/** After the library's own, for a reader with nothing in it yet. */
export const FIRST_STARTERS: Starter[] = [
  { kind: 'ask', label: 'Books to start with', text: 'Suggest a few books to start my library with.' },
  { kind: 'draft', label: 'Books about…', text: 'Suggest books about ' },
];

/**
 * The bar before Explore's code is in: the same box, spark and first
 * example, so nothing moves when the field arrives. Not interactive, so
 * hidden from assistive technology for the moment it shows.
 */
export function AskBarWait({ examples, caption }: { examples: readonly string[]; caption: string }) {
  return (
    <div className="askbar" aria-hidden="true">
      <div className="askbar-field">
        <span className="askbar-spark">
          <Icon name="spark" size={20} />
        </span>
        <div className="askbar-input">
          <span className="askbar-example">{examples[0]}</span>
        </div>
      </div>
      <p className="askbar-caption">{caption}</p>
      <div className="xc-starters" />
    </div>
  );
}
